/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/no-danger */
import { useForm } from '@folklore/forms';
import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useApi } from '../../contexts/ApiContext';
import { useSite } from '../../contexts/SiteContext';
import Button from '../buttons/Button';
import FormGroup from '../fields/FormGroup';
import TextField from '../fields/Text';
// import * as AppPropTypes from '../../lib/PropTypes';
import Label from '../partials/Label';

import styles from '../../../styles/forms/newsletter-form.module.scss';

const propTypes = {
    visible: PropTypes.bool,
    onComplete: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    visible: false,
    onComplete: null,
    className: null,
};

const NewsletterFooter = ({ visible, onComplete, className }) => {
    const intl = useIntl();
    const route = useUrlGenerator();
    const api = useApi();
    const [success, setSuccess] = useState(false);
    const site = useSite();
    const { handle: siteHandle = null } = site || {};

    const subscribe = useCallback(
        (action, data) => api.newsletter.subscribe({ ...data, site: siteHandle }),
        [api, siteHandle],
    );

    const onSuccess = useCallback(() => {
        setSuccess(true);
        if (onComplete !== null) {
            onComplete();
        }
    }, [setSuccess, onComplete]);

    const { fields, onSubmit } = useForm({
        postForm: subscribe,
        fields: ['email'],
        value: null,
        onComplete: onSuccess,
    });

    // TODO: Manage onSuccess better
    // Clear it on success
    useEffect(() => {
        const { onChange: onChangeEmail } = fields.email;
        if (success && onChangeEmail !== null) {
            onChangeEmail('');
        }
    }, [success]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.withLogo]: visible,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.newsletter}>
                <h3 className={styles.title}>
                    <Label>
                        <FormattedMessage
                            defaultMessage="Vous êtes intéressés{br} par notre offre média ?"
                            description="Newsletter form title"
                            values={{ br: <br /> }}
                        />
                    </Label>
                </h3>
                <h3 className={styles.subtitle}>
                    <Label>
                        <FormattedMessage
                            defaultMessage="Abonnez vous à notre infolettre pour rester en contact: "
                            description="Newsletter form  subtitle"
                            values={{ br: <br /> }}
                        />
                    </Label>
                </h3>
                {!success ? (
                    <form
                        className={styles.formContainer}
                        action={route('api.newsletter.subscribe')}
                        onSubmit={onSubmit}
                    >
                        <FormGroup
                            className={styles.formGroup}
                            {...fields.email}
                            label={
                                <FormattedMessage
                                    defaultMessage="Email"
                                    description="Field label"
                                />
                            }
                        >
                            <TextField
                                {...fields.email}
                                className={classNames(styles.input, styles.inputText)}
                                type="email"
                                required
                                autocomplete="off"
                                placeholder={intl.formatMessage({
                                    defaultMessage: 'your@email.ca',
                                    description: 'Subscribe newsletter input placeholder',
                                })}
                            />
                        </FormGroup>
                        <Button className={styles.submit} type="submit">
                            →
                        </Button>
                    </form>
                ) : (
                    <div className={classNames([styles.title, styles.thanks])}>
                        <FormattedMessage defaultMessage="Thanks!" description="Newsletter label" />
                    </div>
                )}
            </div>
        </div>
    );
};

NewsletterFooter.propTypes = propTypes;
NewsletterFooter.defaultProps = defaultProps;

export default NewsletterFooter;
